import { useMemo } from 'react';
import { FilterMultiSelectorProps } from '@access-erp/common';
import { AdvancedFilterCustomRenderProps, DynamicDataMultiselect } from '@access-erp/ui-components';

import { PreloadData } from '@/utils/microfrontend/preloadData';


const BillingTypeMultiSelector = ({
  title,
  value,
  onFilterValueChanged,
  name,
  disabled,
}: FilterMultiSelectorProps<any[]>): React.JSX.Element => {
  const billingTypes = useMemo(() => PreloadData.billingTypes(), []);

  return (
    <DynamicDataMultiselect
      key={`${title}-selector`}
      autocompleteProps={{
        disabled,
        dataTestId: name,
        filterValueChanged: onFilterValueChanged,
        dataFetching: {
          dataMapper: () => {
            return billingTypes.map((item) => ({
              ...item,
              id: item.type,
              value: item.type,
              label: item.formattedType,
            }));
          },
          useGetData: () => ({
            data: billingTypes,
            loading: false,
          }),
        },
        value: value?.map((x) => ({ id: x, label: x, value: x })) ?? [],
      }}
    />
  );
};

export default BillingTypeMultiSelector;

export const renderBillingType = ({
  name,
  onFilterValueChanged,
  title,
  value,
}: AdvancedFilterCustomRenderProps<string[]>): React.JSX.Element => (
  <BillingTypeMultiSelector
    name={name}
    title={title}
    key="billingType"
    value={value}
    onFilterValueChanged={onFilterValueChanged}
  />
);
